import { AxiosInstance } from "axios";

import { 
    ProvincesResponse, 
    Centroide, 
    LocationsWithLatLonResponse, 
    CitiesResponse } from "./types";

export default class LocationsArgentina {
    private axios: AxiosInstance;
    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }
    
    
    public async getAllProvinces(): Promise<ProvincesResponse> {
        const url: string = `https://apis.datos.gob.ar/georef/api/provincias`;
        return this.axios.get(url);
    }

    public async getProvinceByName(name: string): Promise<ProvincesResponse> {
        const url: string = `https://apis.datos.gob.ar/georef/api/provincias?nombre=${name}`;
        return this.axios.get(url);
    }
    
    public async getCityByProvinceId(province: string): Promise<CitiesResponse> {
        const url: string = `https://apis.datos.gob.ar/georef/api/municipios?provincia=${province}&campos=id&max=400`
        return this.axios.get(url);
    }

    public async getProvinceByGeolocation({lat, lon}: Centroide): Promise<LocationsWithLatLonResponse> {
        const url: string = `https://apis.datos.gob.ar/georef/api/ubicacion?lat=${lat}&lon=${lon}`;
        return this.axios.get(url);
    }
}
  